import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProductIntro() {
  return <section id="product" className="py-14 md:py-24 bg-charcoal relative overflow-hidden" data-id="element-292" data-mp="22l5ceye19ei6">
      <div className="max-w-3xl mx-auto px-6 relative z-10 text-center" data-id="element-293" data-mp="1noo0a4y0rvuk">
        <FadeIn data-id="element-294" data-mp="1nqinxr0oe22c">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-offwhite mb-8 leading-tight" data-id="element-295" data-mp="1smz8kb8o1yao">
            <span className="text-sand" data-id="element-296" data-mp="2gca49eb5t2hy">ELEVATE</span> es un proceso de
            transformación de 12 semanas, uno a uno.
          </h2>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-297" data-mp="2lb4zjfqbcjiy">
          <div className="space-y-3 text-xl text-offwhite-dim font-light mb-10 md:mb-12" data-id="element-298" data-mp="26na2xo96pv0l">
            <p data-id="element-299" data-mp="2bm3irnby1y3x">No es un curso.</p>
            <p data-id="element-300" data-mp="2blbku5uvjoah">No es contenido grabado.</p>
            <p data-id="element-301" data-mp="2bk0hg75ccijw">No es una fórmula genérica.</p>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-302" data-mp="2za4l2eij4iaw">
          <div className="bg-charcoal-dark border border-sand/30 p-8 md:p-12 rounded-sm" data-id="element-303" data-mp="2z9ut4ldxc12k">
            <p className="text-xl md:text-2xl font-heading font-bold text-amber mb-6 leading-snug" data-id="element-304" data-mp="344h5orvqrzo8">
              Trabajo con vos para cambiar el observador que produce tu realidad
              actual.
            </p>
            <p className="text-lg text-offwhite-dim" data-id="element-305" data-mp="145hypn5u4nio">
              Simple. Medible. Con acompañamiento real.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}